// 国际化配置文件
export const messages = {
  zh: {
    // 导航
    nav: {
      home: '首页',
      products: '产品中心',
      about: '关于我们'
    },
    // 首页 Hero
    hero: {
      title: '专业工业缝纫设备',
      subtitle: '高品质缝纫机制造商，为全球客户提供卓越的缝纫解决方案',
      browseProducts: '浏览产品'
    },
    // 产品区域
    products: {
      title: '产品中心',
      viewDetail: '查看详情',
      noImage: '暂无图片',
      loading: '正在加载产品数据...'
    },
    // 公司优势
    features: {
      title: '为什么选择我们',
      experience: {
        number: '20+',
        title: '年行业经验',
        desc: '专注工业缝纫设备研发与制造'
      },
      coverage: {
        number: '50+',
        title: '国家覆盖',
        desc: '产品远销全球多个国家和地区'
      },
      support: {
        number: '24/7',
        title: '技术支持',
        desc: '全天候专业技术服务团队'
      },
      quality: {
        number: '100%',
        title: '品质保证',
        desc: '严格质量控制，原厂配件供应'
      }
    },
    // 页脚
    footer: {
      companyDesc: '专注工业缝纫设备研发与制造20年，致力于为全球客户提供高品质的缝纫解决方案。',
      contact: '联系方式',
      address: '浙江省台州市椒江区缝制设备产业园88号',
      phone: '400-888-8888',
      email: 'sales@sunsure-cn.com',
      copyright: '© 2024 VASTI. All Rights Reserved.',
      privacy: '隐私政策',
      terms: '使用条款',
      sitemap: '网站地图'
    },
    // 语言切换
    language: {
      zh: '中文',
      en: 'English'
    },
    // 产品详情页
    productDetail: {
      backToList: '返回产品列表',
      features: '产品特点',
      contactUs: '联系我们',
      emailConsult: '邮件咨询'
    }
  },
  en: {
    // 导航
    nav: {
      home: 'Home',
      products: 'Products',
      about: 'About Us'
    },
    // 首页 Hero
    hero: {
      title: 'Professional Industrial Sewing Equipment',
      subtitle: 'High-quality sewing machine manufacturer, providing excellent sewing solutions for global customers',
      browseProducts: 'Browse Products'
    },
    // 产品区域
    products: {
      title: 'Products',
      viewDetail: 'View Details',
      noImage: 'No Image',
      loading: 'Loading products...'
    },
    // 公司优势
    features: {
      title: 'Why Choose Us',
      experience: {
        number: '20+',
        title: 'Years Experience',
        desc: 'Focused on industrial sewing equipment R&D and manufacturing'
      },
      coverage: {
        number: '50+',
        title: 'Countries',
        desc: 'Products exported to many countries worldwide'
      },
      support: {
        number: '24/7',
        title: 'Technical Support',
        desc: 'Professional technical service team available around the clock'
      },
      quality: {
        number: '100%',
        title: 'Quality Assurance',
        desc: 'Strict quality control, original parts supply'
      }
    },
    // 页脚
    footer: {
      companyDesc: 'Focused on industrial sewing equipment R&D and manufacturing for 20 years, committed to providing high-quality sewing solutions for global customers.',
      contact: 'Contact Us',
      address: 'No.88, Sewing Equipment Industrial Park, Jiaojiang District, Taizhou, Zhejiang, China',
      phone: '400-888-8888',
      email: 'sales@sunsure-cn.com',
      copyright: '© 2024 VASTI. All Rights Reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      sitemap: 'Sitemap'
    },
    // 语言切换
    language: {
      zh: '中文',
      en: 'English'
    },
    // 产品详情页
    productDetail: {
      backToList: 'Back to Products',
      features: 'Product Features',
      contactUs: 'Contact Us',
      emailConsult: 'Email Us'
    }
  }
}

// 获取当前语言
export function getCurrentLocale() {
  return localStorage.getItem('locale') || 'en'
}

// 设置语言
export function setLocale(locale) {
  localStorage.setItem('locale', locale)
}
